import React from "react";
import styled from "styled-components";
import Email from "../../features/personalemailmessages/components/Email";
import PersonalEmailMessages from "../../features/personalemailmessages";
import { usePersonalOutlookContext } from "../../hooks/PersonalOutlookContext";

const EmailLayoutSection = styled.section``;

const PersonalEmailsPage = () => {
    const { mailId } = usePersonalOutlookContext();
    return (
        <React.Fragment>
            <EmailLayoutSection className="col-2 border">
                <PersonalEmailMessages />
            </EmailLayoutSection>
            <EmailLayoutSection className="col">
                {mailId && <Email/>}
            </EmailLayoutSection>
        </React.Fragment>
    );
};

export default PersonalEmailsPage;
